export default "__VITE_ASSET__DxL2mdW7__"